import { gql } from '@apollo/client'

export const connectLinkedIn = gql`
  mutation ConnectLinkedIn($code: String!, $callback: String!) {
    connectLinkedIn(code: $code, callback: $callback)
  }
`
